import { createIconComponent } from '@dreryk/react-components';

const CONTINUOUS_ICON_PATH =
   'M24 18.5H20.5V16.75C20.5 15.72 20.14 14.78 19.55 14.1C22.11 14.439 24 15.61 24 17V18.5ZM0 18.5V17C0 15.61 1.89 14.439 4.45 14.1C3.86 14.78 3.5 15.72 3.5 16.75V18.5H0ZM5.5 16.75C5.5 14.68 8.41 13 12 13C15.59 13 18.5 14.68 18.5 16.75V18.5H5.5V16.75ZM19 6.5C20.657 6.5 22 7.843 22 9.5C22 11.157 20.657 12.5 19 12.5C17.84 12.5 16.84 11.84 16.34 10.88C17.2 9.77 17.62 8.35 17.47 6.92C17.92 6.65 18.44 6.5 19 6.5ZM5 6.5C5.56 6.5 6.08 6.65 6.53 6.92C6.38 8.35 6.8 9.77 7.66 10.88C7.16 11.84 6.16 12.5 5 12.5C3.343 12.5 2 11.157 2 9.5C2 7.843 3.343 6.5 5 6.5ZM12 4C13.933 4 15.5 5.567 15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5C8.5 5.567 10.067 4 12 4Z';

export const ContinuousIcon = createIconComponent('ContinuousIcon', {
   fillRule: 'evenodd',
   clipRule: 'evenodd',
   d: CONTINUOUS_ICON_PATH,
});
